import React from 'react';
import { FormattedMessage } from 'react-intl';

import { NotificationService } from 'ui-components/services/notification-service';

import Global from '../../../store/global-selectors';
import { startActiveLabelCheck } from '../../../store/bulk/print/bulk.print.actions';
import * as JobPipelineActions from '../../../store/job-pipeline/job-pipeline.actions';
import { messages } from '../messages';

export const RequestCanPurchaseLabelStep = (state, jobId) => {
  const jobData = Global.selectJobPipelineJobDataByJobId(state, { jobId });
  if (!jobData || !jobData.notificationId) {
    return [JobPipelineActions.exitJobPipeline(jobId)];
  }
  NotificationService.removeNotification(jobData.notificationId);

  const notificationId = NotificationService.showNotification({
    title: <FormattedMessage {...messages.printNotoTitle} />,
    notificationType: 'info',
    dontHide: true,
    content: <FormattedMessage {...messages.printing} />,
  });

  return [startActiveLabelCheck(jobId), JobPipelineActions.updateJob(jobId, { notificationId })];
};
